(function () {
	const createSwiper = (slider) => {
		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			speed: 250,
			spaceBetween: 0,
			loop: true,
			navigation: {
				nextEl: ".product-button-group .swiper-button-next-1",
				prevEl: ".product-button-group .swiper-button-prev-1",
			},
			pagination: {
				el: " .product-card-pagination",
				clickable: true,
			},
		});

		let savedIndex = null;
		let hoverActive = false;

		const handleMouseEnter = () => {
			if (hoverActive || swiper.slides.length <= 1) {
				return;
			}
			savedIndex = swiper.realIndex;
			hoverActive = true;
			const nextIndex = (savedIndex + 1) % swiper.slides.length;
			swiper.slideToLoop(nextIndex, 300);
		};

		const handleMouseLeave = () => {
			if (!hoverActive || savedIndex === null) {
				return;
			}
			hoverActive = false;
			swiper.slideToLoop(savedIndex, 300);
			savedIndex = null;
		};

		const hoverContainer = slider.closest(".media") ?? slider;
		hoverContainer.addEventListener("mouseenter", handleMouseEnter);
		hoverContainer.addEventListener("mouseleave", handleMouseLeave);
	};

	const initSlider = () => {
		const sliders = document.querySelectorAll(".swiper-container");
		sliders.forEach((slider) => {
			const card = slider.closest(".product-card.card-wrapper");
			if (card && card.dataset.disableSwiper === "true") {
				return;
			}
			if (slider.classList.contains("slider_started")) {
				return;
			}

			slider.classList.add("slider_started");
			createSwiper(slider);
		});
	};

	initSlider();
	document.addEventListener("shopify:section:load", initSlider);
})();
